import * as routing from "@baseline/web/routing/legacy/router-builder";
import { Handler } from "./handler";
import { PredicateFunction, Route, RoutePredicate } from "./route";
import { RoutePath, RoutePathArgumentTypes, RoutePathArgumentsFor } from "./route-path";
import { Router } from "./router";


export * from "@baseline/web/routing/legacy/router-builder";


export interface RouterBuilder
{
    build(): Router;
    when<T extends RoutePathArgumentTypes>(
        path: string,
        options?: Omit<RoutePredicate<T>, "path">
    ): RouteBuilder<Handler<RoutePathArgumentsFor<T>>>;
    when<T extends RoutePathArgumentTypes>(
        routePath: RoutePath<RoutePathArgumentsFor<T>>,
        options?: Omit<RoutePredicate<T>, "path">
    ): RouteBuilder<Handler<RoutePathArgumentsFor<T>>>;
    when<T extends RoutePathArgumentTypes>(
        test: PredicateFunction,
        options?: Omit<RoutePredicate<T>, "test">
    ): RouteBuilder<Handler<RoutePathArgumentsFor<T>>>;
    when<T extends RoutePathArgumentTypes>(
        options: RoutePredicate<T>
    ): RouteBuilder<Handler<RoutePathArgumentsFor<T>>>;
}


export namespace RouterBuilder
{
    export function create(): RouterBuilder
    {
        return new DefaultRouterBuilder();
    }
}


export interface RouteBuilder<H extends Handler = Handler>
{
    handle(...handlers: H[]): RouterBuilder;
    route(routing: (builder: RouterBuilder) => void): RouterBuilder;
}


export class DefaultRouterBuilder extends routing.DefaultRouterBuilder
{
    override handle(...handlers: Handler[]): this
    {
        this.predicate.endPoint ??= true;
        return super.handle(...handlers);
    }

    override build(): Router
    {
        const routes: Route[] = this.routes.map(Route.build);
        return new Router(routes);
    }


    protected override createRouterBuilder(): routing.RouterBuilder
    {
        return new DefaultRouterBuilder();
    }
}
